import { Space, Tooltip } from "antd";
import { SpaceSize } from "antd/es/space";
import { ReactElement, useMemo } from "react";

import { Loc } from "./Loc";
import { Tag } from "./Tag";

type Props<T> = {
  items: T[];
  count?: number;
  spaceSize?: SpaceSize;
  direction?: "horizontal" | "vertical";
  tagSize?: "xs" | "sm" | "md";
  restItemsClassName?: string;
  wrapperClassName?: string;
  ellipsis?: (moreCount: number) => React.ReactNode;
  children: (item: T, index: number) => React.ReactNode;
};

export const TruncateItems: <T>(p: Props<T>) => ReactElement<Props<T>> = ({
  count = 3,
  items = [],
  spaceSize = 2,
  direction,
  tagSize,
  restItemsClassName,
  wrapperClassName,
  ellipsis,
  children,
}) => {
  const visibleItems = useMemo(() => {
    return items.slice(0, count).map((x, i) => children(x, i));
  }, [items, count, children]);

  const restItems = useMemo(() => items.slice(count).map((x, i) => <div key={i}>{children(x, i)}</div>), [items, count, children]);
  const moreCount = useMemo(() => Math.max(0, items.length - count!), [count, items.length]);

  return <>
    <Space size={spaceSize} orientation={direction} className={wrapperClassName}>
      <>{visibleItems}</>
      {ellipsis
        ? <>{ellipsis(moreCount)}</>
        : <>
          {moreCount > 0 && <Tooltip title={<div className={restItemsClassName}>{restItems}</div>}>
            <Tag size={tagSize ?? 'xs'}>
              <Loc word='Global.list.moreItemsTemplate'>
                {moreCount}
              </Loc>
            </Tag>
          </Tooltip>}
        </>}
    </Space>
  </>;
};
